<template>
    <div style="width: 100%;height: 100%;">
      <newIndex v-if="changeRouter === 'admin'"></newIndex>
      <szIndex v-else-if="changeRouter === 'szzhwy'"></szIndex>
    </div>
</template>

<style scoped lang="less"></style>

<script>
    import {
        getItem
    } from '@/utils/auth'
    import newIndex from '@/page/newIndex/index/index'
    import szIndex from '@/page/newIndex/szIndex/index'

    export default {
        name: 'newindex',
        components: {
            newIndex,
            szIndex
        },
        data() {
            return {
              changeRouter: ""
            }
        },
        mounted() {
          if (getItem('userInfo').positionType === '2') {
              this.$message({
                  message: '抱歉，此账号暂无权限',
                  type: 'warning',
                  duration: 2000,
                  onClose() {
                      window.history.back(-1);
                  }
              });
          } else {
            if (getItem('userInfo').screenType && getItem('userInfo').screenType === "szzhwy") {
              this.changeRouter = "szzhwy"
            } else {
              this.changeRouter = "admin"
            }
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/newIndex/index.vue